// extracted by mini-css-extract-plugin
module.exports = {"availability":"AvailabilityBlock_availability___PxId","row":"AvailabilityBlock_row__oXcIZ"};